import { useAtom } from 'jotai';
import { SearchIcon } from 'lucide-react';

import SelectionState from '@/features/trends/components/selections-sidebar/state/selections.state';
import {
  Input,
  InputClear,
  InputField,
  InputLeadingIcon,
} from '@/ux-common/components/input/input';

export const SelectionsSearchInput = () => {
  const [searchTerm, setSearchTerm] = useAtom(SelectionState.searchTerm);

  return (
    <Input data-component="SelectionsSearchInput" className="input-reserve-clear">
      <InputField
        aria-label="Search devices and points"
        placeholder="Search devices and points..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      >
        <InputLeadingIcon>
          <SearchIcon />
        </InputLeadingIcon>
        {searchTerm && <InputClear aria-label="Clear search" onClick={() => setSearchTerm('')} />}
      </InputField>
    </Input>
  );
};
